var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 6.4A8 8 0 1020 12h-8",
    stroke: "#5383EC",
    strokeWidth: 4,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.804 15.5A8 8 0 0012 20c1.892 0 3.63-.657 5-1.755",
    stroke: "#58A65C",
    strokeWidth: 4,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.582 9A7.978 7.978 0 004 12c0 1.255.29 2.443.804 3.5",
    stroke: "#F1BF42",
    strokeWidth: 4,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.713 6.4A8.003 8.003 0 004.581 9",
    stroke: "#D85140",
    strokeWidth: 4,
    fill: "none"
  })));
}

export default SvgGoogle;